import workerUrl from './taillights.worker?worker&url'

export function createTaillightsWorker() {
  return new Worker(workerUrl, {type: 'module'})
}
